import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ChevronRight = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.61121 20.0027C8.46121 20.0027 8.30121 19.9427 8.19121 19.8227C7.95121 19.5727 7.94121 19.1727 8.18121 18.9127L14.5412 12.0027L8.17121 5.09268C7.94121 4.83268 7.94121 4.43268 8.18121 4.18268C8.42121 3.93268 8.80121 3.94268 9.04121 4.19268L15.8312 11.5527C16.0612 11.8027 16.0612 12.1927 15.8312 12.4427L9.04121 19.8027C8.92121 19.9327 8.76121 20.0027 8.60121 20.0027H8.61121Z" />
  </svg>
)

export default withDefaultStyles(ChevronRight)
